export default __webpack_public_path__ + "static/media/68.78986042.png";